import React, { useEffect, useRef } from 'react';

import styles from './flappy.module.css';

interface FlappyGameProps {
  gameKey?: any;
  gameSettings?: any;
}

const FlappyGame: React.FC<FlappyGameProps> = ({ gameKey, gameSettings }) => {
  console.log('FlappyGame component rendered with:', { gameKey, gameSettings });
  
  const gameContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!gameContainerRef.current) return;

    // Получаем buildId из URL параметров или из gameKey
    const urlParams = new URLSearchParams(window.location.search);
    let buildId = urlParams.get('buildId');
    
    // Если buildId нет в URL, но есть в gameKey, используем его
    if (!buildId && gameKey && gameKey.gameBuildId) {
      buildId = gameKey.gameBuildId;
    }

    // Создаем div для игры (как в оригинальном HTML)
    const gameDiv = document.createElement('div');
    gameDiv.id = 'flappy-bird-reborn';
    gameDiv.style.width = '100%';
    gameDiv.style.height = '100vh';
    
    gameContainerRef.current.innerHTML = '';
    gameContainerRef.current.appendChild(gameDiv);

    // Передаем buildId в глобальную переменную для игры
    (window as any).buildId = buildId;
    (window as any).gameSettings = gameSettings;

    // Загружаем Phaser.js
    const loadPhaser = () => {
      return new Promise<void>((resolve, reject) => {
        if ((window as any).Phaser) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = '/src/pages/_Games/Flappy/js/phaser.js';
        script.onload = () => {
          console.log('Phaser.js loaded successfully');
          resolve();
        };
        script.onerror = () => {
          reject(new Error('Failed to load Phaser.js'));
        };
        document.head.appendChild(script);
      });
    };

    // Загружаем игровую логику
    const loadGameLogic = () => {
      return new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = '/src/pages/_Games/Flappy/js/game-custom.js';
        script.onload = () => {
          console.log('Game logic loaded successfully');
          resolve();
        };
        script.onerror = () => {
          reject(new Error('Failed to load game logic'));
        };
        document.head.appendChild(script);
      });
    };

    // Инициализируем игру
    const initGame = async () => {
      try {
        await loadPhaser();
        await loadGameLogic();
        
        console.log('Flappy Bird game initialized with buildId:', buildId);
      } catch (error) {
        console.error('Error loading Flappy Bird game:', error);
      }
    };

    initGame();

    // Очистка при размонтировании
    return () => {
      if (gameContainerRef.current) {
        gameContainerRef.current.innerHTML = '';
      }
    };
  }, [gameKey, gameSettings]);

  return (
    <div className={styles.flappyGameContainer}>
      <div ref={gameContainerRef} className={styles.gameCanvas} />
    </div>
  );
};

export default FlappyGame;
